"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LayersIcon = function LayersIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M15.71 11.487l-7.4 4.441a.738.738 0 0 1-.635 0L.27 11.487a.272.272 0 0 1 0-.508l.913-.547 6.49 3.895a.738.738 0 0 0 .635 0l6.49-3.895.912.547a.271.271 0 0 1 0 .508zm0-3.74L14.8 7.2l-6.49 3.894a.738.738 0 0 1-.635 0L1.184 7.2l-.913.547a.272.272 0 0 0 0 .507l7.403 4.442a.738.738 0 0 0 .635 0l7.402-4.442a.271.271 0 0 0 0-.507zM.272 5.022l7.403 4.441a.738.738 0 0 0 .635 0l7.402-4.441a.271.271 0 0 0 0-.508L8.309.073a.738.738 0 0 0-.635 0L.27 4.514a.272.272 0 0 0 0 .508z"
    }) : _react["default"].createElement("path", {
      d: "M14.376 9.573l1.647.927-8 4.5-8-4.5 1.648-.927 1.02.574-.628.353 5.96 3.353 5.96-3.353-.627-.353zm-.999-2.414l.606.341-5.96 3.353L2.063 7.5l.607-.341-1.02-.574L.023 7.5l8 4.5 8-4.5-1.626-.915zM8.023.023l-8 4.5 8 4.5 8-4.5zm-5.96 4.5l5.96-3.352 5.96 3.352-5.96 3.353z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M23.727 17.23l-11.25 6.662a1.138 1.138 0 0 1-.967 0L.26 17.229a.406.406 0 0 1 0-.761l2.076-1.23 8.458 5.008a2.514 2.514 0 0 0 2.396.002l8.459-5.01 2.078 1.231a.404.404 0 0 1 0 .76zm0-5.61l-2.078-1.23-8.46 5.01a2.512 2.512 0 0 1-2.396-.004L2.336 10.39.26 11.619a.406.406 0 0 0 0 .762l11.25 6.662a1.138 1.138 0 0 0 .967 0l11.25-6.662a.404.404 0 0 0 0-.76zM.26 7.533l11.25 6.662a1.138 1.138 0 0 0 .967 0l11.25-6.662a.405.405 0 0 0 0-.761L12.477.108a1.138 1.138 0 0 0-.967 0L.26 6.771a.406.406 0 0 0 0 .761z"
    }) : _react["default"].createElement("path", {
      d: "M21.357 13.922L23.5 15.19 12 22C.2 15.01 1.428 15.74.5 15.188c.527-.309.262-.15 2.145-1.266l.981.58-1.161.688L12 20.838l9.536-5.648-1.161-.687zm-1.23-3.267l1.41.835-9.536 5.648-9.536-5.648 1.41-.835-.98-.58C.736 11.351 1.05 11.165.5 11.487c.927.553-.3-.176 11.5 6.813l11.5-6.81-2.392-1.416zM12 .686C-.111 7.859 1.429 6.948.5 7.493c.926.55-.302-.178 11.5 6.812l11.5-6.81zm-9.536 6.81C3.049 7.148 12 1.848 12 1.848l9.536 5.646L12 13.142z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M31.422 22.973l-14.803 8.883a1.48 1.48 0 0 1-1.271 0L.545 22.973a.543.543 0 0 1 0-1.016l3.29-1.976 11.513 6.908a1.48 1.48 0 0 0 1.271 0l11.51-6.907 3.293 1.977a.541.541 0 0 1 0 1.014zm0-7.479l-3.293-1.976-11.51 6.906a1.48 1.48 0 0 1-1.271 0L3.836 13.516.545 15.492a.543.543 0 0 0 0 1.016l14.803 8.883a1.48 1.48 0 0 0 1.271 0l14.803-8.883a.541.541 0 0 0 0-1.014zM16.619.144a1.48 1.48 0 0 0-1.271 0L.545 9.028a.543.543 0 0 0 0 1.016l14.803 8.883a1.48 1.48 0 0 0 1.271 0l14.803-8.883a.543.543 0 0 0 0-1.016z"
  }) : _react["default"].createElement("path", {
    d: "M27.686 19.573l3.294 1.854L16 29.854 1.02 21.427l3.293-1.854 1.014.57-2.266 1.284L16 28.705l12.94-7.278-2.275-1.28zm-.965-4.237l2.218 1.237L16 23.852 3.06 16.573l2.205-1.245-1.02-.573-3.225 1.818L16 25l14.98-8.427-3.233-1.815zM16 20.219l14.98-8.427L16 3.365 1.02 11.792zm0-15.705l12.94 7.278L16 19.071 3.06 11.792z"
  }));
};

var _default = LayersIcon;
exports["default"] = _default;